import { Component, inject } from '@angular/core';
import { CreateUserCommand } from '@era/security-sdk';

import { UserStoreActions, UserStoreSelectors } from '@era/stores';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AddUserModalComponent } from '../add-user-modal/add-user-modal.component';
import { UserListComponent } from './user-list.component';

@Component({
  selector: 'era-user-list',
  templateUrl: './user-list.container.html',
  imports: [UserListComponent],
})
export class UserListContainerComponent {
  private readonly store = inject(Store);
  private readonly actions$ = inject(Actions);
  private readonly modalService = inject(NgbModal);

  public readonly users = this.store.selectSignal(UserStoreSelectors.selectAllUsers);
  public readonly error$: Observable<string>;
  public editEnabled = false;

  constructor() {
    this.error$ = this.actions$
      .pipe(ofType(UserStoreActions.UserApiActions.usersLoadedError))
      .pipe(map(() => 'An unknown error has occurred.'));
  }

  toggleEditEvent(): void {
    this.editEnabled = !this.editEnabled;
  }

  addUserEvent(): void {
    const modelRef = this.modalService.open(AddUserModalComponent);
    modelRef.result.then(
      (result: CreateUserCommand) => {
        this.store.dispatch(UserStoreActions.UserListUIActions.userAddRequested({ user: result }));
      },
      () => {
        return;
      }
    );
  }
}
